import { render, staticRenderFns } from "./Profile.vue?vue&type=template&id=593988f4&scoped=true"
import script from "./Profile.vue?vue&type=script&lang=ts&setup=true"
export * from "./Profile.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./Profile.vue?vue&type=style&index=0&id=593988f4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "593988f4",
  null
  
)

export default component.exports